// extracted by mini-css-extract-plugin
export default {"container":"Ly-z","brandName":"My-z","genderTreatment":"Ny-z","productName":"Oy-z","aboveGalleryInfo":"Py-z","belowGalleryInfo":"Qy-z","breakLongProductName":"Ry-z"};